module.exports = {
  emptyMessage: 'กรุณากรอกวันหมดอายุของบัตร',
  expiredMessage: 'อุ๊ปส์! บัตรที่คุณกรอกหมดอายุแล้ว',
  defaultMessage: 'วันหมดอายุไม่ถูกต้อง',
};
